<template>
  <div class="page-components">
    <div class="columns">
      <div class="column content" style="margin-bottom:15px;">
        <p class="title">Components</p>
        <p class="subtitle">Describing Components</p>
      </div>
    </div>
    <div v-for="wrapper in wrapperList" :class="wrapper.class">
      <div v-for="component in wrapper.componentList" :class="component.class">
        <div v-for="item in component.itemList" :class="item.class">
          <p v-if="item.content && item.content.type === 'title'" class="title">{{ item.content.title }}</p>
          <p v-if="item.content && item.content.type === 'title'" class="subtitle">{{ item.content.subtitle }}</p>

          <div class="columns" v-if="!component.nocontrol">
            <div class="column has-text-right">
                <p><a @click="addComponent(wrapper.componentList, 1);component.nocontrol=true">add column <i class="material-icons md-18">arrow_forward</i></a></p>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="box content" style="background-color:#eee;">
          <p><a @click="addComponents(wrapperList, 1)"><i class="material-icons md-18">arrow_downward</i> add row</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      wrapperList: [{
        id: 1,
        class: 'columns',
        componentList: [{
          id: 101,
          class: 'column',
          itemList: [{
            class: 'box',
            content: {
              type: 'title',
              title: 'Title Here',
              subtitle: 'Subtitle Here'
            }
          }]
        }]
      }]
    }
  },
  methods: {
    addComponents: function (wrapperListObj, count) {
      for (var i = count; i > 0; i--) {
        var columnsObj = {
          class: 'columns',
          componentList: []
        }
        this.addComponent(columnsObj.componentList, 1)
        wrapperListObj.push(columnsObj)
      }
    },
    addComponent: function (componentListObj, column) {
      for (var i = column; i > 0; i--) {
        var columnObj = {
          class: 'column',
          itemList: []
        }
        // columnsObj.componentList.push(columnObj)
        componentListObj.push(columnObj)
        for (var j = 1; j > 0; j--) {
          var itemObj = {
            class: 'box',
            content: {
              type: 'title',
              title: 'Title Here',
              subtitle: 'Subtitle Here'
            }
          }
          columnObj.itemList.push(itemObj)
        }
      }
    }
  },
  created () {
    console.log('created Components.vue')
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";

.page-components {
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// Components.vue?255363ba